var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container no-margin"},[_c('div',{staticClass:"autoselect-options-container"},[(_vm.showDropdown)?_c('div',{staticClass:"autoselect-options"},_vm._l((_vm.filteredOptions),function(option){return _c('div',{key:option.label +
            ' - ' +
            option.direccion +
            ' , ' +
            option.localidad +
            ' , ' +
            option.provincia},[_c('span',{attrs:{"title":option.label +
              ' - ' +
              option.direccion +
              ',' +
              option.localidad +
              ' , ' +
              option.provincia},on:{"click":function($event){return _vm.onOptionClick(option)}}},[_vm._v(_vm._s(option.label + " - " + option.direccion + " , " + option.localidad + " , " + option.provincia))])])}),0):_vm._e(),(_vm.showCaret)?_c('img',{staticClass:"caret",attrs:{"src":_vm.caret,"alt":"seleccion-sucursal"},on:{"click":_vm.toggleDropdown}}):_vm._e()]),_c('text-input',{ref:"textInput",staticClass:"text-input",attrs:{"hint":"Sucursal","label":"Escribí una dirección o sucursal","value":_vm.selectedValue,"required":_vm.required,"subhint":_vm.subhint,"validationError":_vm.validationError},on:{"input":_vm.onInput,"onFocus":_vm.onFocus,"onBlur":_vm.onBlur,"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }